export default "__VITE_ASSET__iTxc2RJW__"